/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Passkey_Error_Must_LoginInputs */



/**
* | output |
* | --- |
* | "You must be signed in to register a passkey." |
*
* @param {Passkey_Error_Must_LoginInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const passkey_error_must_login = /** @type {((inputs?: Passkey_Error_Must_LoginInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Passkey_Error_Must_LoginInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vous devez être connecté pour enregistrer une Passkey.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Debe iniciar sesión para registrar un Passkey.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Você precisa estar conectado para registrar uma Passkey.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Devi aver effettuato l'accesso per registrare una Passkey.")
	return /** @type {LocalizedString} */ ("You must be signed in to register a passkey.")
});